/**
 * sp-complete-set.js — "Vervollständige dein Set" Bundle (Amazon-Stil "Frequently bought together").
 * - Checkbox-Toggle aktualisiert die Live-Gesamtsumme und das Button-Label.
 * - "Alle in den Warenkorb" fügt alle angehakten Varianten in EINEM Request hinzu,
 *   feuert das Theme-Event `cart:update` (Drawer + Gratisversand-Balken hören darauf)
 *   und öffnet den Warenkorb-Drawer.
 * Reines Custom-Element, keine Theme-Modul-Imports (robust gegen Theme-Updates).
 */
(function () {
  'use strict';

  function shopRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/+$/, '');
  }

  function formatEuro(cents) {
    var value = (Number(cents) || 0) / 100;
    try {
      return value.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    } catch (e) {
      return value.toFixed(2).replace('.', ',') + ' €';
    }
  }

  class SpCompleteSet extends HTMLElement {
    connectedCallback() {
      this.checkboxes = Array.prototype.slice.call(this.querySelectorAll('[data-fbt-check]'));
      this.totalEl = this.querySelector('[data-fbt-total]');
      this.button = this.querySelector('[data-fbt-add]');
      this.labelEl = this.querySelector('[data-fbt-add-label]');
      this.liveEl = this.querySelector('[data-fbt-live]');
      if (!this.button || !this.checkboxes.length) return;

      this._onChange = this.refresh.bind(this);
      this.checkboxes.forEach((cb) => cb.addEventListener('change', this._onChange));
      this.button.addEventListener('click', this.addAll.bind(this));

      // Aktuelles Produkt live mit dem Varianten-Picker synchronisieren
      this.currentCheckbox = this.querySelector('[data-current="true"]');
      this.currentProductId = this.currentCheckbox ? this.currentCheckbox.dataset.productId : null;
      if (this.currentProductId) {
        this._onVariant = this.handleVariant.bind(this);
        document.addEventListener('variant:update', this._onVariant);
      }

      this.refresh();
    }

    disconnectedCallback() {
      if (this._onVariant) document.removeEventListener('variant:update', this._onVariant);
    }

    /** Preis/Verfügbarkeit/Varianten-ID des aktuellen Produkts aktualisieren, wenn der Kunde die Variante wechselt. */
    handleVariant(event) {
      var detail = event && event.detail;
      if (!detail || !detail.resource || !this.currentCheckbox) return;
      if (String(detail.data && detail.data.productId) !== String(this.currentProductId)) return;

      var v = detail.resource;
      if (v.id != null) this.currentCheckbox.dataset.variantId = v.id;
      if (typeof v.price === 'number') {
        this.currentCheckbox.dataset.price = v.price;
        var item = this.currentCheckbox.closest('.sp-fbt__item');
        var priceEl = item && item.querySelector('.sp-fbt__price');
        if (priceEl) priceEl.textContent = formatEuro(v.price);
      }
      if (v.available === false) {
        this.currentCheckbox.checked = false;
        this.currentCheckbox.disabled = true;
      } else {
        this.currentCheckbox.disabled = false;
      }
      this.refresh();
    }

    get checked() {
      return this.checkboxes.filter((cb) => cb.checked && !cb.disabled);
    }

    refresh() {
      var items = this.checked;
      var total = items.reduce((sum, cb) => sum + (parseInt(cb.dataset.price, 10) || 0), 0);
      if (this.totalEl) this.totalEl.textContent = formatEuro(total);

      var n = items.length;
      if (this.labelEl) {
        if (n <= 1) {
          this.labelEl.textContent = this.dataset.labelOne || 'In den Warenkorb';
        } else {
          this.labelEl.textContent = (this.dataset.labelMany || 'Alle {n} in den Warenkorb').replace('{n}', n);
        }
      }
      this.button.disabled = n === 0;
    }

    /** Für das aktuelle Produkt die LIVE gewählte Variante aus dem Produktformular lesen. */
    resolveVariantId(cb) {
      if (cb.dataset.current === 'true') {
        var input =
          document.querySelector('product-form-component [name="id"]') ||
          document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (input && input.value) return input.value;
      }
      return cb.dataset.variantId;
    }

    setBusy(busy) {
      this.button.setAttribute('aria-busy', busy ? 'true' : 'false');
      this.button.disabled = busy || this.checked.length === 0;
      if (this.labelEl && busy) this.labelEl.textContent = this.dataset.labelBusy || 'Wird hinzugefügt …';
    }

    announce(msg) {
      if (this.liveEl) this.liveEl.textContent = msg;
    }

    async addAll() {
      var checked = this.checked;
      if (!checked.length) return;

      var seen = {};
      var items = [];
      checked.forEach((cb) => {
        var id = this.resolveVariantId(cb);
        if (id && !seen[id]) {
          seen[id] = true;
          items.push({ id: id, quantity: 1 });
        }
      });
      if (!items.length) return;

      var root = shopRoot();
      var sectionIds = Array.prototype.slice
        .call(document.querySelectorAll('cart-items-component'))
        .map((el) => el.dataset.sectionId)
        .filter(Boolean);

      var body = { items: items };
      if (sectionIds.length) {
        body.sections = sectionIds.join(',');
        body.sections_url = window.location.pathname;
      }

      this.setBusy(true);
      try {
        var res = await fetch(root + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        var data = await res.json();

        if (!res.ok || data.status) {
          this.announce(data.description || data.message || 'Konnte nicht hinzugefügt werden.');
          this.setBusy(false);
          this.refresh();
          return;
        }

        // Vollen Warenkorb holen (für den Gratisversand-Balken: resource.total_price)
        var cart = null;
        try {
          cart = await (await fetch(root + '/cart.js', { headers: { Accept: 'application/json' } })).json();
        } catch (e) {
          /* Balken hat eigenen Fallback */
        }

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: this.id || 'sp-complete-set',
              data: {
                source: 'sp-complete-set',
                itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : items.length,
                sections: data.sections,
              },
            },
          })
        );

        // Im Warenkorb (data-context="cart") NICHT navigieren/Drawer öffnen —
        // das cart:update-Event morpht die Warenkorb-Section (Artikel + FBT-Box aktualisieren sich von selbst).
        if (this.dataset.context !== 'cart') {
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else {
            window.location.href = root + '/cart';
            return;
          }
        }

        this.announce('Zum Warenkorb hinzugefügt.');
      } catch (e) {
        this.announce('Ein Fehler ist aufgetreten. Bitte versuche es erneut.');
      } finally {
        this.setBusy(false);
        this.refresh();
      }
    }
  }

  if (!customElements.get('sp-complete-set')) {
    customElements.define('sp-complete-set', SpCompleteSet);
  }
})();
